/**
 * Справочный блок «Склад» в «Аналитике МП» и «Аналитике опт» — пока скрыт (решение владельца 23.10.2026: «пока рано
 * выводить»). Витрина DWH и ручки бэкенда остаются; включить — `true` здесь.
 */
export const WAREHOUSE_BLOCK_ENABLED = false;
